import _ from 'lodash'
import * as R from 'ramda'
import P from 'helpers/predicates'
import store from 'configureStore'

function updateObject(oldObject, newValues){
  return { ...oldObject, ...newValues }
}

function updateFilteredItemInArray(array, updatePredicate, updateItemCallback){
  const updatedItems = array.map((item, index, array) => {
    let updated_item = item

    if( updatePredicate(item, index, array) ) updated_item = updateItemCallback(item)

    return updated_item
  })

  return updatedItems
}

function updateItemItemInArrayWithId(array, updateId, updateItemCallback){
  const predicate = ({id}, itemIndex) => id === updateId
  return updateFilteredItemInArray(array, predicate, updateItemCallback)
}

function updateItemInArray(array, index, updateItemCallback){
  const predicate = (item, itemIndex) => itemIndex === index
  return updateFilteredItemInArray(array, predicate, updateItemCallback)
}

function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action, sharedState) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action, sharedState)
    } else {
      return state
    }
  }
}

const createFilteredReducer = _.curry((reducerPredicate, reducerFunction) => {
  return (state, action) => {
    const isInitializationCall = state === undefined
    const shouldRunWrappedReducer = reducerPredicate(action) || isInitializationCall
    return shouldRunWrappedReducer ? reducerFunction(state, action) : state
  }
})

// Requires the name value and the reducer function
const createNamedReducer = _.curry((name, reducer) => createFilteredReducer(action => action.name === name, reducer))

// to debug any state changes
const logReducer = (s) => {
  console.log(s)
  return s
}

const getState = () => {
  return store.getState()
}

export {
  updateObject,
  updateFilteredItemInArray,
  updateItemItemInArrayWithId,
  updateItemInArray,
  createReducer,
  getState,
  createFilteredReducer,
  createNamedReducer,
  logReducer,
}
